import { OcppLogMessageFormatted } from '@delmonicos/shared-sdk/libs/cpms/src/libs/ocpp/src/logger/ocpp-logs-messsages.interface';
import { useTranslation } from 'react-i18next';

import { LogItemWrapper } from './log-item-wrapper.component';

export const DefaultLogComponent = ({
  log,
}: {
  log: OcppLogMessageFormatted;
}): React.JSX.Element => {
  const { t } = useTranslation();
  const { message } = log;

  return (
    <LogItemWrapper call={message}>
      <small>
        {t('$.charge-point-details.maintenance.log.application')}:{' '}
        {log.labels.application} -{' '}
        {t('$.charge-point-details.maintenance.log.operation')}:{' '}
        {log.labels.operation}
      </small>
    </LogItemWrapper>
  );
};
